// extracted by mini-css-extract-plugin
export default {"videoContainer":"style_videoContainer__QsbF-"};